module.exports = __webpack_public_path__ + "img/t3-black.82424a1e.png";